import { Outlet } from 'react-router-dom';
import Menu from "./Menu";
import Header from "./Header"

const Layout = () => {

    return (
        <>
            <Header />
            <Menu />
            <main><Outlet /></main>
        </>
    )
}

export default Layout;